import styled, { css } from "styled-components";

export const LargeIconButtonContainer = styled.div<{ disabled?: boolean }>`
  color: ${({ theme: { palette }, disabled }) => (disabled ? palette.iconDisabled : palette.textSecondary)};
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 1.5rem;

  ${({ disabled }) => disabled && "pointer-events: none"};
`;

export const textContainerMixin = css`
  font: ${({ theme: { fonts } }) => fonts.small};
  max-width: 6rem;
  text-align: left;
`;

export const TextContainer = styled.div`
  ${textContainerMixin};
`;
